import { styled } from "@pigment-css/react";
import type { MonthlyBreakdown } from "@acto/taskpane/core/data-access/customers/useCustomerKpiFigures";

interface MonthlyBreakdownListProps {
  breakdown: MonthlyBreakdown[];
  formatValue: (value: number) => string;
}

const List = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.managementView.spacing[2],
}));

const Row = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: `${theme.managementView.spacing[10]} 0`,
}));

const MonthLabel = styled("span")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[14],
  fontWeight: theme.managementView.font.weight[500],
  color: theme.managementView.colors.neutral[56],
}));

const ValueWrapper = styled("div")({
  display: "flex",
  alignItems: "baseline",
  gap: "8px",
});

const MonthValue = styled("span")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[15],
  fontWeight: theme.managementView.font.weight[500],
  color: theme.managementView.colors.neutral[90],
}));

const ChangeValue = styled("span")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[14],
  fontWeight: theme.managementView.font.weight[400],
  color: theme.managementView.colors.neutral[56],
}));

export const MonthlyBreakdownList = ({ breakdown, formatValue }: MonthlyBreakdownListProps) => {
  return (
    <List>
      {breakdown.map((entry) => (
        <Row key={entry.periodStart}>
          <MonthLabel>{entry.month}</MonthLabel>
          <ValueWrapper>
            <MonthValue>{formatValue(entry.value)}</MonthValue>
            {entry.change !== null && (
              <ChangeValue>
                {entry.change >= 0 ? "+" : ""}
                {entry.change}%
              </ChangeValue>
            )}
          </ValueWrapper>
        </Row>
      ))}
    </List>
  );
};
